<form (ngSubmit)="onSubmit()" [formGroup]="form">

    <div >
      <input [placeholder]="'FORM.CARD_NUM_PH' | translate" autocomplete="off" name="cardNumber" id="cardNumber" type="text" pattern="([0-9]){4,4}" minlength="4" maxlength="4" (keyup)="submitted=false;" formControlName="cardNumber" />
      <div class="form-error" [hidden]="!(form.controls['cardNumber'].invalid && firstSubmitted)">
        <span></span>
        <span [innerHtml]="'FORM.CARD_NUM_PH' | translate"></span>
      </div>
      <label for="cardNumber" [innerHtml]="'FORM.CARD_NUM' | translate"></label>
    </div>

    <div>
        <input aria-label="MileagePlus account number" [placeholder]="'FORM.MP_NUM_PH' | translate" autocomplete="off" name="mpId" type="text" pattern="([a-zA-Z0-9]){8,8}" minlength="8" maxlength="8" (keyup)="submitted=false;" formControlName="mpId"  />
        <div class="form-error" [hidden]="!(form.controls['mpId'].invalid && firstSubmitted)">
          <span></span>
          <span [innerHtml]="'FORM.MP_NUM_PH' | translate"></span>
        </div>
      <label for="mpId" [innerHtml]="'FORM.MP_NUM' | translate"></label>
      <a class="forgot" target="_blank" [href]="'FORM.FORGOT_LINK' | translate" [attr.aria-label]="'FORM.FORGOT_LINK_ARIA' | translate" [innerHtml]="'FORM.FORGOT' | translate"></a>
    </div>

    <div class="form-btn">
      <button [disabled]="submitted" tabindex="0">
        @if(loading) {
          <span [class.show]="loading">
            <img [src]="imageBaseUrl + 'loading.svg'" alt="Loading" />
          </span>
        } @else {
          <span [class.show]="!loading" [innerHtml]="'FORM.CTA_BTN' | translate"></span>
        }
      </button>
    </div>
  </form>